document.addEventListener("DOMContentLoaded", main);

function main() {
  const header = document.querySelector(".header");
  const openHamburger = document.querySelector(".header .hamburger");
  const closeHamburger = document.querySelector(".mobileNav .hamburger");
  const mobileNav = document.querySelector(".mobileNav");
  const mobileNavBackground = document.querySelector(".mobileNav__background");
  const hamburgers = [openHamburger, closeHamburger];
  const floatingButtons = document.querySelector(".floatingButtons");
  hamburgers.forEach((hamburger) => {
    hamburger.addEventListener("click", () => {
      hamburgers.forEach((h) => {
        h.classList.toggle("hamburger--opened");
      });
      // header.classList.toggle("header--scrolled");
      hamburger.setAttribute("aria-expanded", hamburger.classList.contains("hamburger--opened"));
      mobileNav.classList.toggle("mobileNav--open");
      mobileNavBackground.classList.toggle("mobileNav--open");
    });
  });
  window.addEventListener("scroll", () => {
    document.body.scrollTop > 40 || document.documentElement.scrollTop > 40
      ? header.classList.add("header--scrolled")
      : header.classList.remove("header--scrolled");
    if (floatingButtons) {
      document.body.scrollTop > 40 || document.documentElement.scrollTop > 40
        ? floatingButtons.classList.add("floatingButtons--scrolled")
        : floatingButtons.classList.remove("floatingButtons--scrolled");
    }
  });

  if (document.querySelector(".gallery")) {
    const databases__swiper = new Swiper(".gallery__swiper .swiper", {
      slidesPerView: 1,
      loop: 1,
      pagination: {
        el: ".gallery .swiper-pagination",
        clickable: true,
      },
      navigation: {
        prevEl: ".gallery__prev",
        nextEl: ".gallery__next",
      },
      breakpoints: {
        900: {
          spaceBetween: 20,
          slidesPerView: 3,
        },
        1380: {
          spaceBetween: 32,
          slidesPerView: 3,
        },
      },
    });
  }
  if (document.querySelector(".modal")) {
    var modal = document.getElementById("modal");
    var modalOverlay = document.querySelector("#modal-overlay");
    var closeButton = document.querySelector("#close-button");
    closeButton.addEventListener("click", () => {
      modal.classList.add("closed");
      modalOverlay.classList.add("closed");
    });

    const formOpenButtons = document.querySelectorAll(".formButton");

    formOpenButtons.forEach((formButton) => {
      formButton.addEventListener("click", () => {
        modal.classList.remove("closed");
        modalOverlay.classList.remove("closed");
      });
    });
  }

  const links = document.querySelectorAll(".convertionLink");

  links.forEach((link) => {
    link.addEventListener("click", (e) => {
      if (window.innerWidth > 900) {
        if (!!!link.classList.contains("convertionLink--show")) {
          e.preventDefault();
          link.classList.add("convertionLink--show");
          link.querySelector("span").innerHTML = link.getAttribute("data-text");
        }
      } else {
      }
    });
  });
}

